import { render, staticRenderFns } from "./purchase-list.vue?vue&type=template&id=c57d337a"
import script from "./purchase-list.js?vue&type=script&lang=js&external"
export * from "./purchase-list.js?vue&type=script&lang=js&external"
import style0 from "./purchase-list.vue?vue&type=style&index=0&id=c57d337a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports